import { SlicePipe } from '@angular/common';
import { inject, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncate',
  standalone: true,
})
export class TruncatePipe implements PipeTransform {
  private slicePipe = inject(SlicePipe);

  transform(value: string, maxLength: number): any {
    const suffix = value && value.length > maxLength ? '...' : '';
    return this.slicePipe.transform(value, 0, maxLength) + suffix;
  }
}
